import { render, staticRenderFns } from "./bienestar_cirujanos.vue?vue&type=template&id=250137fe&scoped=true&"
import script from "./bienestar_cirujanos.vue?vue&type=script&lang=js&"
export * from "./bienestar_cirujanos.vue?vue&type=script&lang=js&"
import style0 from "./bienestar_cirujanos.vue?vue&type=style&index=0&id=250137fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250137fe",
  null
  
)

export default component.exports